import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrd$dGeneric from "../Data.Ord.Generic/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import {naturalKeyImpl} from "./foreign.js";
const $SortChunk = (tag, _1) => ({tag, _1});
const Num = value0 => $SortChunk("Num", value0);
const Str = value0 => $SortChunk("Str", value0);
const naturalKey = /* #__PURE__ */ naturalKeyImpl(Num)(Str);
const genericSortChunk = {
  to: x => {
    if (x.tag === "Inl") { return $SortChunk("Num", x._1); }
    if (x.tag === "Inr") { return $SortChunk("Str", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Num") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Str") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showSortChunk = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "Num"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "Str"});
    return x => {
      if (x.tag === "Num") { return $0["genericShow'"](x._1); }
      if (x.tag === "Str") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const eqSortChunk = {
  eq: x => y => {
    if (x.tag === "Num") {
      if (y.tag === "Num") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "Str") {
      if (y.tag === "Str") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordSortChunk = {
  compare: /* #__PURE__ */ (() => {
    const $0 = Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrd.ordInt.compare(v)(v1)})({"genericCompare'": v => v1 => Data$dOrd.ordString.compare(v)(v1)});
    return x => y => $0["genericCompare'"]((() => {
      if (x.tag === "Num") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
      if (x.tag === "Str") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
      $runtime.fail();
    })())((() => {
      if (y.tag === "Num") { return Data$dGeneric$dRep.$Sum("Inl", y._1); }
      if (y.tag === "Str") { return Data$dGeneric$dRep.$Sum("Inr", y._1); }
      $runtime.fail();
    })());
  })(),
  Eq0: () => eqSortChunk
};
export {$SortChunk, Num, Str, eqSortChunk, genericSortChunk, naturalKey, ordSortChunk, showSortChunk};
export * from "./foreign.js";
